export default {
    sim_provider_create_title: "Crear Proveedor de Sim",
    sim_provider_same_name_exits: "Ya existe un proveedor de sim con el mismo nombre",
    sim_provider_create_success_message: "Se ha creado el proveedor de sim",
    sim_provider_edit_title: "Editar Proveedor de Sim",
    sim_provider_edit_success_message: "Se ha editado el proveedor de sim",
    sim_provider_name: "Nombre",
}